import { PATHS } from 'Config/Routing/paths'
import { authorization } from 'Module/Auth/Auth'
import React from 'react'
import injectStyles from 'react-jss'
import { PageNav, PageNavItem } from '../../../../Components/PageNav'
import { NAV } from '../../../../Config/Routing/nav'
import {
  CAMPAIGN_ENUM_TYPES,
  CAMPAIGN_SUBTYPES_ENUM,
  CAMPAIGN_INTERNAL_STATUSES,
} from '../../../../shared/constants'
import CampaignFeaturesConfig from '../../../Form/Campaigns/CreateEditCampaign/CampaignFeaturesConfig'

const styles = {
  wrapper: {
    marginLeft: '40px',
  },
}
export const CampaignHeaderNav = injectStyles(styles)(
  ({ history, showBonusTab, campaignId, campaign }) => {
    const isEDDM = campaign && campaign.subtype === CAMPAIGN_SUBTYPES_ENUM.EDDM
    const isADM = campaign && campaign.subtype === CAMPAIGN_SUBTYPES_ENUM.ADM

    const isDraftSelfServeCampaign =
      campaign &&
      campaign.selfServeData &&
      campaign.selfServeData[0] &&
      campaign.selfServeData[0].internalStatus ===
        CAMPAIGN_INTERNAL_STATUSES.DRAFT

    const isRejectedSelfServeCampaign =
      campaign &&
      campaign.selfServeData &&
      campaign.selfServeData[0] &&
      campaign.selfServeData[0].internalStatus ===
        CAMPAIGN_INTERNAL_STATUSES.REJECTED

    const internalStatus =
      !!campaign &&
      !!campaign.selfServeData &&
      !!campaign.selfServeData[0] &&
      campaign.selfServeData[0].internalStatus

    const shouldShowInternalFiles =
      isEDDM || isADM
        ? !isDraftSelfServeCampaign && !isRejectedSelfServeCampaign
        : true

    const BASE_URL =
      PATHS.main.dashboard + PATHS.dashboard.campaigns + '/' + campaignId + '/'
    const user = authorization.getUser()
    const isClientsRole =
      authorization.isClient() || authorization.isClientAdmin()

    const isApprovedSelfServeCampaign = internalStatus
      ? [
          CAMPAIGN_INTERNAL_STATUSES.GENERATING_DIGITAL_PROOF,
          CAMPAIGN_INTERNAL_STATUSES.PAYMENT,
          CAMPAIGN_INTERNAL_STATUSES.ACTIVE,
          CAMPAIGN_INTERNAL_STATUSES.COMPLETED,
        ].includes(internalStatus)
      : false

    const {
      disableBAFeatures,
      disableUploadCodes,
      enableArtwork,
      enableArtworkAndOffers,
    } = CampaignFeaturesConfig(campaign.type, campaign.subtype)

    const isCityManagerAssistant = authorization.isCityManagerAssistant()
    const hotfixHidePreviousCreatedADMCampaigns = new Set([
      6865,
      6866,
      6867,
      6787,
    ])

    return (
      <PageNav history={history}>
        {!isCityManagerAssistant ? (
          <PageNavItem href={BASE_URL + NAV.CAMPAIGN_HEADER_NAV.DASHBOARD}>
            Dashboard
          </PageNavItem>
        ) : null}

        {enableArtwork && (
          <PageNavItem
            href={
              BASE_URL +
              NAV.CAMPAIGN_HEADER_NAV.DASHBOARD +
              PATHS.campaign.artwork
            }
          >
            Artwork
          </PageNavItem>
        )}
        {enableArtworkAndOffers && !campaign.isSelfServe && (
          <PageNavItem
            href={
              BASE_URL +
              NAV.CAMPAIGN_HEADER_NAV.DASHBOARD +
              PATHS.campaign.artworkAndOffers
            }
          >
            Artwork & Offers
          </PageNavItem>
        )}

        {isApprovedSelfServeCampaign && isEDDM && (
          <PageNavItem
            href={BASE_URL + NAV.CAMPAIGN_HEADER_NAV.METRICS_BREAKDOWN}
          >
            Metrics breakdown
          </PageNavItem>
        )}

        {(authorization.isCityManager() || authorization.isClient()) &&
        !authorization.isSpy() &&
        campaign.type !== CAMPAIGN_ENUM_TYPES.DIRECTMAIL &&
        !disableBAFeatures ? (
          <PageNavItem href={BASE_URL + NAV.CAMPAIGN_HEADER_NAV.LIVE_MAP}>
            Live Map
          </PageNavItem>
        ) : null}
        {(user.countryCode == 'US' && isClientsRole) ||
        disableBAFeatures ? null : (
          <PageNavItem href={BASE_URL + NAV.CAMPAIGN_HEADER_NAV.CITY_PLANS}>
            City Plans
          </PageNavItem>
        )}
        {!disableBAFeatures && !isCityManagerAssistant ? (
          <PageNavItem
            href={BASE_URL + NAV.CAMPAIGN_HEADER_NAV.MASTER_SCHEDULE}
          >
            Master Schedule
          </PageNavItem>
        ) : null}
        {disableBAFeatures && CAMPAIGN_ENUM_TYPES.INSERTS === campaign.type ? (
          <PageNavItem
            href={BASE_URL + NAV.CAMPAIGN_HEADER_NAV.CODE_MANAGEMENT}
          >
            Code Management
          </PageNavItem>
        ) : null}
        {!authorization.isClient() && !disableBAFeatures && (
          <PageNavItem
            href={BASE_URL + NAV.CAMPAIGN_HEADER_NAV.MANAGE_PAID_AMOUNTS}
          >
            Client Permit Costs
          </PageNavItem>
        )}
        {showBonusTab && !disableBAFeatures && !isCityManagerAssistant ? (
          <PageNavItem href={BASE_URL + NAV.CAMPAIGN_HEADER_NAV.BONUS_RESULTS}>
            Bonus Results
          </PageNavItem>
        ) : null}
        {!isClientsRole && !disableBAFeatures ? (
          <PageNavItem
            href={BASE_URL + NAV.CAMPAIGN_HEADER_NAV.CLIENT_QUESTIONS}
          >
            Client Questions
          </PageNavItem>
        ) : null}

        {campaign.isSelfServe &&
          authorization.isAdmin() &&
          !disableUploadCodes && (
            <PageNavItem href={BASE_URL + NAV.CAMPAIGN_HEADER_NAV.UPLOAD_CODES}>
              Codes
            </PageNavItem>
          )}

        {authorization.isAdmin() &&
          isADM &&
          !hotfixHidePreviousCreatedADMCampaigns.has(Number(campaignId)) && (
            <PageNavItem href={BASE_URL + NAV.CAMPAIGN_HEADER_NAV.MAILING_LIST}>
              Mailing List
            </PageNavItem>
          )}
        {(authorization.isAdmin() || isClientsRole) && isADM && (
          <PageNavItem
            href={BASE_URL + NAV.CAMPAIGN_HEADER_NAV.DETAILED_TRACKING}
          >
            Detailed Tracking
          </PageNavItem>
        )}
        {authorization.isAdmin() && shouldShowInternalFiles && (
          <PageNavItem href={BASE_URL + NAV.CAMPAIGN_HEADER_NAV.INTERNAL_FILES}>
            Internal Files
          </PageNavItem>
        )}
        {authorization.isAdmin() && (
          <PageNavItem href={BASE_URL + NAV.CAMPAIGN_HEADER_NAV.CONVERSIONS}>
            Conversions
          </PageNavItem>
        )}
        {authorization.isCityManager() && !isCityManagerAssistant ? (
          <PageNavItem href={BASE_URL + NAV.CAMPAIGN_HEADER_NAV.LOGS}>
            Logs
          </PageNavItem>
        ) : null}
      </PageNav>
    )
  },
)
export default CampaignHeaderNav
